import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

//utils
import { NavSlides } from '../../utils/navCarousel';


function CarouselSection({ title, accentColor, backgroundColor, sliderItems, idx}) {

  const [currentSlide, setCurrentSlide] = useState(0)
  const [sliderRef, slider] = useKeenSlider({
    initial: 0,
    spacing: 10,
    slidesPerView: 1.08,
    mode: "free-snap",
    duration: 850,

    breakpoints: {
      '(min-width: 374px)': {
        slidesPerView: 1.08,
        spacing: 12,
      },
      '(min-width: 413px)': {
        slidesPerView: 1.08,
        spacing: 12,
      },
      '(min-width: 480px)': {
        slidesPerView: 1.55,
        spacing: 15,
      },
      '(min-width: 640px)': {
        slidesPerView: 1.46,
        spacing: 28,
      },
      '(min-width: 680px)': {
        slidesPerView: 2.15,
        spacing: 28,
      },
      '(min-width:767px)': {
        slidesPerView: 2.1,
        spacing: 28,
      },
      '(min-width:819px)': {
        slidesPerView: 2.2,
        spacing: 28,
      },
      '(min-width: 1024px)': {
        slidesPerView: 2.6,
        spacing: 28,
      },
      '(min-width: 1279px)': {
        slidesPerView: 3,
        spacing: 28,
        slideChanged(s) {
          setCurrentSlide(s.details().relativeSlide)
        },
      },
    },
  });

  return (
    <section className={`${idx === 0 ? 'pt-48 sm:pt-72 lg:pt-44 pb-14 sm:pb-12 lg:pb-14' : 'pb-14 sm:pb-12 lg:pb-14'} pt-20 sm:pt-24 lg:pt-44  pl-5 sm:pl-7 pr-0 lg:px-20`} style={{ backgroundColor: `${backgroundColor}` }}>
      <h6 className={'relative pb-4 sm:pb-6 lg:pb-12 text-6xl sm:text-8xl lg:text-9xlg font-comp font-bold uppercase leading-none'} style={{ color: `${accentColor}` }}>
        {title}
        <span className={'absolute bottom-0 left-0.5 w-11 sm:w-93px lg:w-52 h-1 sm:h-5px lg:h-2.5'} style={{ backgroundColor: `${accentColor}` }}></span>
      </h6>

      <div className={'mt-14 sm:mt-70px lg:mt-32'}>
        <div ref={sliderRef} className="keen-slider">

          {sliderItems.map((item, idx) => {
            const { image, link, date, eventDetails, slug } = item.fields;
            return(
              eventDetails ? (
                <div className={'keen-slider__slide mlg:max-w-25 mlg:min-w-25'} key={idx}>
                  <Link to={`/press-events/${slug}`} className={'inline-block'} rel="noreferrer">
                    <img className={'w-full h-40 xs:h-227px object-cover object-center'} src={image.fields.file.url} alt={title} />
                    <div>
                      <span className={'block text-sm sm:text-lg lg:text-sm text-gray-79 font-medium mt-3 sm:mt-5'}>{date}</span>
                      <div className={'text-base sm:text-2xl lg:text-xl text-base-color font-medium mt-2 sm:mt-3 leading-tight'}>
                        {item.fields.title}
                      </div>
                    </div>
                  </Link>
                </div>
              )
              :
              (
                <div className={'keen-slider__slide mlg:max-w-25 mlg:min-w-25'} key={idx}>
                  <a href={link} className={'inline-block'} target="_blank" rel="noreferrer">
                    <img className={'w-full h-40 xs:h-227px object-cover object-center'} src={image.fields.file.url} alt={title} />
                    <div>
                      <span className={'block text-sm sm:text-lg lg:text-sm text-gray-79 font-medium mt-3 sm:mt-5'}>{date}</span>
                      <div className={'text-base sm:text-2xl lg:text-xl text-base-color font-medium mt-2 sm:mt-3 leading-tight'}>
                          {item.fields.title}
                      </div>
                    </div>
                  </a>
                </div>
              )
            )
          })}


        </div>

        {slider &&  (
          <div className={'relative hidden xl:flex justify-center items-center mt-16'}>
            <NavSlides sliderItems={sliderItems.length > 3} slider={slider} currentSlide={currentSlide} />
          </div>
        )}

      </div>
    </section>
  )
}

export default CarouselSection;
